import {
  Notifications,
  Shower,
  Science,
  Construction,
  Home,
  Web,
  Dock,
  Person,
  ExpandLess,
  ExpandMore,
  TableRows,
} from "@mui/icons-material";
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import ecoisAPI from "../../../../api/ecois";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

export default function TopBarTabs({ isPhone = false, setState, state, onTabChange }) {
  const { t } = useTranslation();

  const tabs = [
    { label: "dashboard", icon: <Home />, onClick: () => onTabChange("dashboard", 0) },
    { label: "projects", icon: <Web />, onClick: () => onTabChange("projects", 0) },
    { label: "devices", icon: <Dock />, onClick: () => onTabChange("devices", 0) },
    {
      label: "profile",
      icon: <Person />,
      onClick: () => onTabChange("profile", 0),
    },
    {
      label: "notif_settings",
      icon: <Notifications />,
      onClick: () => onTabChange("notif_settings", 0),
      disabled: process.env.NODE_ENV !== "development",
    },
  ];

  const [waterControlOpen, setWaterControlOpen] = useState(false);
  const [referenceCommandsOpen, setReferenceCommandsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleWaterControlToggle = () => setWaterControlOpen(!waterControlOpen);
  const handleReferenceCommandsToggle = () => setReferenceCommandsOpen(!referenceCommandsOpen);
  const handleDebugToggle = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTestInput = (call) => {
    const sn = 71715619362418;
    const from = 20231129;
    const to = 20231212;
    const types = ["relativeHumidity", "pm10"];
    const time = "2023-12-02%2022:33:01";
    const params = {
      getDeviceList: {},
      getDeviceDetails: { sn },
      getDeviceDescription: { sn },
      getSensorValueByTimeRangeAndTypes: { sn, from, to, types },
      getSensorValueListLatest: { sn },
      getSensorValueListByTimestamp: { sn, time },
    }[call];
    if (params) {
      Swal.fire("請等候伺服器回傳...");
      Swal.showLoading();
      ecoisAPI[call](params).then((res) => {
        Swal.fire({
          title: "範例API指令成功",
          html: `<style> 
                      textarea {
                          width: 100%;
                          height: 720px;
                          padding: 12px 20px;
                          box-sizing: border-box;
                          border: 2px solid #ccc;
                          border-radius: 4px;
                          background-color: #fefefe;
                          font-size: 16px;
                          resize: none;
                      }
                  </style><h4>回傳數據:</h4><br>
                  <textarea>${JSON.stringify(res, null, 4)}</textarea>`,
          width: "1080px",
        });
      });
    }
  };

  const renderDebugMenuItems = () => {
    return (
      process.env.NODE_ENV === "development" && (
        <>
          <ListItem disablePadding>
            <ListItemButton onClick={handleWaterControlToggle}>
              <ListItemIcon>
                <Shower />
              </ListItemIcon>
              <ListItemText primary='水閘控制' />
              {waterControlOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={waterControlOpen} timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem>
                  <ListItemButton onClick={() => ecoisAPI.openWaterValve()}>
                    <ListItemText primary='開水閘' />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton onClick={() => ecoisAPI.closeWaterValve()}>
                    <ListItemText primary='關水閘' />
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton disabled>
              <ListItemIcon>
                <Shower />
              </ListItemIcon>
              <ListItemText primary='自動水閘控制' />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleReferenceCommandsToggle}>
              <ListItemIcon>
                <Science />
              </ListItemIcon>
              <ListItemText primary='參考指令回傳' />
              {referenceCommandsOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={referenceCommandsOpen} timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem>
                  <ListItemButton onClick={() => handleTestInput("getDeviceList")}>
                    <ListItemText primary='取得設備清單' />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton onClick={() => handleTestInput("getDeviceDetails")}>
                    <ListItemText primary='取得設備資料' />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton onClick={() => handleTestInput("getDeviceDescription")}>
                    <ListItemText primary='取得設備傳感器資料' />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => handleTestInput("getSensorValueByTimeRangeAndTypes")}
                  >
                    <ListItemText primary='根據時間段和傳感器種類<br>取得數據' />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton onClick={() => handleTestInput("getSensorValueListLatest")}>
                    <ListItemText primary='取得傳感器清單最新數據' />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton onClick={() => handleTestInput("getSensorValueListByTimestamp")}>
                    <ListItemText primary='根據時間點取得傳感器<br>清單數據' />
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </>
      )
    );
  };
  const [phoneMenuAnchorEl, setPhoneMenuAnchorEl] = useState(null);
  const phoneMenuOpen = Boolean(phoneMenuAnchorEl);
  const handlePhoneMenuOnClickTab = (callback) => {
    callback();
    setPhoneMenuAnchorEl(null);
  };

  const handlePhoneMenuClick = (event) => {
    setPhoneMenuAnchorEl(event.currentTarget);
  };

  const handlePhoneMenuClose = () => {
    setPhoneMenuAnchorEl(null);
  };

  //// Phone UI
  if (isPhone) {
    return (
      <>
        <IconButton color='inherit' onClick={handlePhoneMenuClick}>
          <TableRows />
        </IconButton>
        <Menu
          anchorEl={phoneMenuAnchorEl}
          open={phoneMenuOpen}
          onClose={handlePhoneMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {tabs.map((tab) => (
            <MenuItem
              sx={{ textTransform: "none" }}
              key={tab.label}
              onClick={() => handlePhoneMenuOnClickTab(tab.onClick)}
              color={state.pageTab === tab.label ? "primary" : "inherit"}
              disabled={tab.disabled}
            >
              <ListItemText primary={t(`main.topbar_${tab.label}`)} />
            </MenuItem>
          ))}
        </Menu>
        <IconButton onClick={handleDebugToggle}>
          <Science />
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Menu
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          placement='bottom-start'
          sx={{ zIndex: 1000 }}
        >
          <Box
            sx={{
              borderRadius: "4px",
              zIndex: 1,
            }}
          >
            <List component='div' disablePadding>
              {renderDebugMenuItems()}
              <ListItem disablePadding>
                <ListItemButton disabled>
                  <ListItemIcon>
                    <Construction />
                  </ListItemIcon>
                  <ListItemText primary='v0.06@25/06/20' />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Menu>
      </>
    );
  }

  ////

  return (
    <>
      {tabs.map((tab) => (
        <Button
          sx={{ textTransform: "none" }}
          key={tab.label}
          onClick={tab.onClick}
          color={state.pageTab === tab.label ? "primary" : "inherit"}
          disabled={tab.disabled}
        >
          {t(`main.topbar_${tab.label}`)}
        </Button>
      ))}
      <IconButton onClick={handleDebugToggle}>
        <Science />
        {open ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        placement='bottom-start'
        sx={{ zIndex: 1000 }}
      >
        <Box
          sx={{
            borderRadius: "4px",
            zIndex: 1,
          }}
        >
          <List component='div' disablePadding>
            {renderDebugMenuItems()}
            <ListItem disablePadding>
              <ListItemButton disabled>
                <ListItemIcon>
                  <Construction />
                </ListItemIcon>
                <ListItemText primary='v0.06@25/06/20' />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Menu>
    </>
  );
}
